import { Box, Typography } from '@mui/material';
import {
  ColumnDirective,
  ColumnsDirective,
  Filter,
  GridComponent,
  Inject,
  Page,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { useState } from 'react';
import { dateTemplate } from '../GenTask/components/SharedFormFields';
import useGetLengthChecker from './hooks/useGetLengthChecker';
import { makeStyles } from '@material-ui/core';
import ProductsModal from './ProductModal';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
}));

function LengthChecker() {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [selectedLengthId, setSelectedLengthId] = useState(null);

  const { lengthCheckerData } = useGetLengthChecker();

  const handleLengthIDClick = lengthID => {
    setSelectedLengthId(lengthID);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedLengthId(null);
  };

  // Custom cell template for clickable lengthID
  const lengthIDTemplate = props => (
    <span
      onClick={() => handleLengthIDClick(props.lengthID)}
      style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}>
      {props.lengthID}
    </span>
  );

  return (
    <div className="app-wrapper">
      <Box className={classes.header}>
        <Typography variant="h4">Length Checker</Typography>
      </Box>

      <GridComponent
        dataSource={lengthCheckerData}
        allowPaging={true}
        pageSettings={{ pageSize: 15 }}
        toolbar={['Search']}
        height="600px">
        <ColumnsDirective>
          <ColumnDirective
            field="lengthID"
            headerText="Length ID"
            width="100"
            isPrimaryKey={true}
            template={lengthIDTemplate}
          />
          <ColumnDirective field="date" headerText="Date and Time" width="100" type="datetime" formatter={dateTemplate} />
          <ColumnDirective field="forestSP" headerText="SP Name" width="150" />
          <ColumnDirective field="recordEnteredBy" headerText="Record Entered By" width="150" />
          <ColumnDirective field="employeeName" headerText="Employee Name" width="120" textAlign="Right" />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter, Toolbar]} />
      </GridComponent>

      <ProductsModal open={openModal} lengthId={selectedLengthId} onClose={handleCloseModal} />
    </div>
  );
}

export default LengthChecker;
